import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<h1>add template detail page here</h1>",{ moduleName: "garaje/pods/communications/message-log/detail/template.hbs" })